import * as React from 'react'
import styled from '@emotion/styled'
import { CustomDrawer } from '@yuno/design-system-web'
import { WebhooksForm } from '../webhooks-form'
import { palette } from '@yuno/design-system-web'
import DrawerMessages from '../drawer-messages'
import { useTranslation } from 'react-i18next'

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
`

export const WebhooksDrawerForm = ({
  code = null,
  fields,
  handleSubmit,
  open,
  title,
  hasSuccess = false,
  onPrimaryAction,
  onSecondaryAction,
  onClose,
  primaryLabel,
  isLoading = false,
  mode,
  webhooksList = [],
  hasError = { isError: false, isGeneric: true },
  nameWebhook = '',
}) => {
  const [name, setName] = React.useState(nameWebhook)
  const [formValid, setFormValid] = React.useState(hasSuccess)
  const { isError, isGeneric } = hasError
  const { t } = useTranslation()

  const primaryAction = hasSuccess ? onPrimaryAction : isError ? onClose : null
  const secondaryAction = hasSuccess || isError ? null : onSecondaryAction

  const primaryLabelText =
    isError && isGeneric
      ? t('tryAgain')
      : isError && !isGeneric
      ? t('gotIt')
      : primaryLabel || t('add')

  return (
    <CustomDrawer
      title={title}
      onPrimaryAction={primaryAction}
      onSecondaryAction={secondaryAction}
      onClose={onClose}
      primaryType="submit"
      formId="WebhookForm-form"
      primaryLabel={primaryLabelText}
      secondaryLabel={t('cancel')}
      anchor="right"
      open={open}
      isFormValid={formValid}
      loading={isLoading}
    >
      <Wrapper>
        {isError && isGeneric && (
          <DrawerMessages
            icon="Plugs"
            title={t('connectionFailed')}
            subtitle={t('problemAddingWebhook')}
            color={palette.vivid.coral}
          />
        )}

        {isError && !isGeneric && (
          <DrawerMessages
            icon="XCircle"
            title={t('attemptFailed')}
            subtitle={t('hasWebhook')}
            color={palette.vivid.coral}
          />
        )}

        {hasSuccess && (
          <DrawerMessages
            icon="CheckCircle"
            title={t('webhookAdded')}
            subtitle={`${t('webhookAddedOne')}${name}${t('webhookAddedTwo')}`}
          />
        )}

        {!hasSuccess && !isError && (
          <WebhooksForm
            webhooksList={webhooksList}
            code={code}
            fields={fields}
            mode={mode}
            onSubmit={(code, form) => {
              setName(form['NAME'])
              handleSubmit(code, form)
            }}
            setFormValid={(isValid: boolean) => setFormValid(isValid)}
          />
        )}
      </Wrapper>
    </CustomDrawer>
  )
}
